
import React, { useState,useCallback,useEffect } from 'react';
import { motion } from 'motion/react';
import { Mic, MicOff, Volume2, Radio } from 'lucide-react';
import { useSession } from './SessionProvider';
import {
  useConnectionState,
  useVoiceAssistant,
  BarVisualizer,
  TrackToggle,
  useLocalParticipant,
  useMediaDeviceSelect,
} from "@livekit/components-react";

import { Track } from "livekit-client";
// import { AgentControlBar } from './agent-control-bar/agent-control-bar';
import { MultibandAudioVisualizer } from './MultibandAudioVisualizer';
import { useMultibandTrackVolume } from "../hooks/use-multiband-track-volume";

const MotionBottom = motion.create('div');

const IN_DEVELOPMENT = process.env.NODE_ENV !== 'production';
const BOTTOM_VIEW_MOTION_PROPS = {
  variants: {
    visible: {
      opacity: 1,
      translateY: '0%',
    },
    hidden: {
      opacity: 0,
      translateY: '100%',
    },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: {
    duration: 0.3,
    delay: 0.5,
    ease: 'easeOut',
  },
};

export function Fade({ top = false, bottom = false, className }) {
  return (
    <div
      className={`
        'from-background pointer-events-none h-4 bg-linear-to-b to-transparent',
        ${top}  'bg-linear-to-b',
        ${bottom}  'bg-linear-to-t',
        ${className}`
      }
    />
  );
}

export const SessionView = ({...props }) => {

   const localParticipant = useLocalParticipant();
   const localMultibandVolume = useMultibandTrackVolume(
    localParticipant.microphoneTrack?.track,
    9,
  );
  const [isMuted, setIsMuted] = useState(localParticipant.isMicrophoneEnabled);

    const { isSessionActive, endSession } = useSession();
    const connectionState = useConnectionState();
    const { audioTrack, state } = useVoiceAssistant();
    const handleDisconnect = useCallback(async () => {
        endSession();
        
      }, [endSession]);

    console.log("audioTrack", audioTrack);
  

  useEffect(() => {
    setIsMuted(localParticipant.isMicrophoneEnabled === false);
  }, [localParticipant.isMicrophoneEnabled]);

  return (
 

    <div >
    <div className="h-screen flex items-center justify-center">
    <section className="bg-background flex flex-col items-center text-center">
        

       

        <div className="flex w-full items-center">
      <div className="h-[320px] mt-16 md:mt-0 lg:pb-24 w-full">
        <BarVisualizer
          state={state}
          barCount={10}
          trackRef={audioTrack}
          className="w-full h-full"
        />
      </div>
    </div>

        <MotionBottom
        {...BOTTOM_VIEW_MOTION_PROPS}         >
        
        <div className="bg-background relative mx-auto mt-12 max-w-2xl pb-3 md:pb-12">
        <div className="flex  gap-20">
          <div className="flex items-center gap-4">
            <TrackToggle
              source={Track.Source.Microphone}
              className={`shadow-none${isMuted ? " opacity-50" : ""}`}
              showIcon={false}
            >
              {isMuted ? (
                <MicOff className="h-8 w-8" />
              ) : (
                <Mic className="h-8 w-8" />
              )}
            </TrackToggle>
            <MultibandAudioVisualizer
              state="speaking"
              barWidth={2}
              minBarHeight={2}
              maxBarHeight={26}
              frequencies={localMultibandVolume}
              borderRadius={5}
              gap={2}
            />
          </div>
          
          <button
            onClick={handleDisconnect}
            disabled={!isSessionActive}
            type="button"
             className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 
             hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 
             dark:focus:ring-blue-800 font-medium rounded-lg text-sm 
             h-12 px-8 text-center leading-none flex items-center justify-center"
          >
            Disconnect
          </button>
        </div>
          
        </div>
      </MotionBottom>
    </section>

   
    </div>
    </div>


  );
};
